// loads scripts that need to be on page - every entrypoint should import this!
import { AdLoader, lazyload } from '@datagraphics/cookbook';
import { openFeedbackForm, closeFeedbackForm } from './feedbackform';

document.addEventListener('DOMContentLoaded', () => {
  // Kickstart image lazy loading
  lazyload();
  // Kickstart ads
  const adLoader = new AdLoader({ adSection: window.AD_SECTION });
  adLoader.init();
});

// Write your code!
import { renderSvelteComponent } from './utils/render.js';

//components
import FrontPage from './components/FrontPage.svelte';

let page = document.getElementById('here');

renderSvelteComponent(FrontPage, /** @type {HTMLElement} */ (page), {});

// nav button
let dropdownButton = document.querySelector('.dropdown button');
let dropdownMenu = document.querySelector('.dropdown-menu');
let icon = document.querySelector('.plus');
let navItems = document.querySelectorAll('.nav-item');

// nav items hidden
function toggleTabIndexOnNav(i) {
  let currentTabIndex = i.getAttribute('tabindex');
  if (currentTabIndex == '-1') {
    i.setAttribute('tabindex', '0');
  } else {
    i.setAttribute('tabindex', '-1');
  }
}
function OpenCloseMenu() {
  // aria expanded
  let ariaAttribute = dropdownButton.getAttribute('aria-expanded');
  dropdownButton.setAttribute(
    'aria-expanded',
    ariaAttribute === 'true' ? 'false' : 'true'
  );
  icon.classList.toggle('minus');
  // dropdown menu
  dropdownMenu.classList.toggle('hidden');
  // dropdown menu visible to screen readers
  // aria expanded
  let dropdownMenuAriaAttribute = dropdownMenu.getAttribute('aria-hidden');
  dropdownMenu.setAttribute(
    'aria-hidden',
    dropdownMenuAriaAttribute === 'true' ? 'false' : 'true'
  );
  // toggle items tabbable
  navItems.forEach((item) => toggleTabIndexOnNav(item));
}

dropdownButton.addEventListener('click', function (e) {
  OpenCloseMenu();
});

// hide nav once you make a selection
let linksInMenu = dropdownMenu.querySelectorAll('a');
linksInMenu.forEach((link) => {
  link.addEventListener('click', function (e) {
    // hide menu and reset aria-hidden attribute to true
    OpenCloseMenu();
    closeFeedbackForm();
  });
});

// scroll into view for nav anchor tags
let navLinks = document.querySelectorAll('div.dropdown-menu ul.sections-nav a');
navLinks.forEach((elem) => {
  elem.addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector(elem.getAttribute('href')).scrollIntoView({
      behavior: 'smooth',
    });
  });
});

// feedbackform
let feedbackform = document.getElementById('feedback_form');
let formLink = document.querySelector('.feedback');

formLink.addEventListener('click', function (e) {
  openFeedbackForm();
});

formLink.addEventListener('keypress', function (e) {
  if (e.key == 'Enter') {
    OpenCloseMenu();
    openFeedbackForm();
  }
});

let exitForm = document.querySelector('.exit-form');

exitForm.addEventListener('click', function (e) {
  closeFeedbackForm();
});

// exitForm.addEventListener('keypress', function (e) {
//   if (e.key == 'Enter') {
//     closeFeedbackForm();
//   }
// });

document.onkeydown = function (e) {
  e = e || window.event;
  if (e.key == 'Escape' && feedbackform.classList.contains('show')) {
    closeFeedbackForm();
  }
};

// adding capitalize function to String

String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};
